export default "/images/project4.jpg?c6c8179662635266eca56175dda06181";